<template functional>
  <label>
    <input
      type="checkbox"
      :checked="props.value"
      @change="listeners.input($event.target.checked)"
    >
    <span class="toggle" />
    <slot />
  </label>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

label {
  position:relative;
  cursor: pointer;
  padding-left: 30px;
  flex: 1 0 auto;
  width: 33.33%;
  max-width: 33.33%;
  display: flex;
  margin-bottom: 0.35rem;

  input {
    display: none;

    &:checked ~ .toggle {
      background-color: rgba($color: #fff, $alpha: 1);

      &::after {
        display: block;
      }
    }
  }

  .toggle {
    position: absolute;
    top: 0;
    left: 0;
    height: 16px;
    width: 16px;
    border: 2px solid #fff;
    margin-top: 2px;
    border-radius: 3px;
    transition: all 250ms ease-in-out;

    &:after {
      content: "";
      position: absolute;
      display: none;
      left: 3px;
      top: 0;
      width: 6px;
      height: 11px;
      border: solid $color-main-darker;
      border-width: 0 3px 3px 0;
      transform: rotate(40deg);
    }
  }

  &:hover input ~ .toggle {
    background-color: rgba($color: #fff, $alpha: 1);
  }
}
</style>
